/**
 * Static catalog สำหรับหน้า Landing (Gold Dark)
 * ------------------------------------------------------------------
 * ค่ายเกมยังไม่ได้เชื่อม backend — ข้อมูลทั้งหมดในไฟล์นี้ใช้ asset
 * จากเว็บ demo (public/lux/*) เมื่อพร้อมเชื่อมข้อมูลจริง ให้แก้ `code`
 * ของแต่ละค่ายให้ตรงกับ productId ของ backend แล้วระบบจะส่งต่อ
 * ไปหน้าหมวดพร้อม ?provider=<code> ให้อัตโนมัติ
 */

const A = "/lux";

/* ------------------------------------------------------------ categories */
export const LUX_CATEGORIES = [
  { id: "hot", label: "ยอดฮิต", sub: "Hot", icon: `${A}/icons/cat-hot.webp`, tab: "hot" },
  { id: "casino", label: "คาสิโนสด", sub: "Live Casino", icon: `${A}/icons/cat-casino.webp`, path: "/livecasino", tab: "casino" },
  { id: "slot", label: "สล็อต", sub: "Slots", icon: `${A}/icons/cat-slot.webp`, path: "/slot", tab: "slot" },
  { id: "sport", label: "กีฬา", sub: "Sports", icon: `${A}/icons/cat-sport.webp`, path: "/sportbook", tab: "sport" },
  { id: "fishing", label: "ยิงปลา", sub: "Fishing", icon: `${A}/icons/cat-fishing.webp`, path: "/card", tab: "fishing" },
  { id: "card", label: "เกมไพ่", sub: "Cards", icon: `${A}/icons/cat-card.webp`, path: "/card", tab: "casino" },
  { id: "lotto", label: "หวย / คีโน", sub: "Lotto", icon: `${A}/icons/cat-lotto.webp`, path: "/keno", tab: "lotto" },
  { id: "esport", label: "อีสปอร์ต", sub: "E-Sports", icon: `${A}/icons/cat-esport.webp`, path: "/sportbook", tab: "sport" },
];

/* ------------------------------------------------------------ provider showcase */
const card = (file) => `${A}/cards/${file}.webp`;
const tile = (file) => `${A}/tiles/${file}.webp`;

/**
 * shape: "portrait" (3:4 ตัวละคร), "tile" (300x255), "wide" (600x330)
 * type : ใช้กับเงื่อนไขประเภทเกมของผู้ใช้ (slot | casino | sport | fishing)
 */
export const LUX_SHOWCASE = [
  {
    id: "hot",
    label: "ยอดฮิต",
    icon: `${A}/icons/cat-hot.webp`,
    groups: [
      {
        title: "เกมยอดนิยมประจำสัปดาห์",
        shape: "tile",
        items: [
          { name: "Sexy Baccarat", code: "SEXY", type: "casino", path: "/livecasino", img: tile("ht-2"), badge: "HOT" },
          { name: "Joker Gaming", code: "JOKER", type: "slot", path: "/slot", img: tile("ht-5"), badge: "HOT" },
          { name: "PG Soft", code: "PG", type: "slot", path: "/slot", img: tile("ht-6"), badge: "HOT" },
          { name: "Thai Hi-Lo", code: "SEXY", type: "casino", path: "/livecasino", img: tile("img-aesexy-thaihilo") },
          { name: "JILI", code: "JILI", type: "slot", path: "/slot", img: tile("uf-5ht"), badge: "NEW" },
          { name: "Kingmaker", code: "KINGMAKER", type: "casino", path: "/livecasino", img: tile("uf-7") },
          { name: "SA Gaming", code: "SA", type: "casino", path: "/livecasino", img: tile("lc-2-th") },
          { name: "Evolution", code: "EVOLUTION", type: "casino", path: "/livecasino", img: tile("img-evo") },
          { name: "Pragmatic Play", code: "PP", type: "slot", path: "/slot", img: tile("img-pp") },
          { name: "Red Tiger", code: "REDTIGER", type: "slot", path: "/slot", img: tile("uf-9") },
          { name: "eBET", code: "EBET", type: "casino", path: "/livecasino", img: tile("img-ebet") },
          { name: "Golden Casino", code: "GOLDEN", type: "casino", path: "/livecasino", img: tile("lc-5") },
        ],
      },
    ],
  },
  {
    id: "casino",
    label: "คาสิโนสด",
    icon: `${A}/icons/cat-casino.webp`,
    groups: [
      {
        title: "ค่ายคาสิโนสด",
        shape: "portrait",
        items: [
          { name: "SA Gaming", code: "SA", type: "casino", path: "/livecasino", img: card("casino-sa") },
          { name: "Sexy Gaming", code: "SEXY", type: "casino", path: "/livecasino", img: card("casino-sexy") },
          { name: "Dream Gaming", code: "DG", type: "casino", path: "/livecasino", img: card("casino-dream") },
          { name: "eBET", code: "EBET", type: "casino", path: "/livecasino", img: card("casino-ebet") },
          { name: "Big Gaming", code: "BG", type: "casino", path: "/livecasino", img: card("casino-big") },
          { name: "Green Dragon", code: "GD", type: "casino", path: "/livecasino", img: card("casino-green") },
          { name: "Pretty Gaming", code: "PRETTY", type: "casino", path: "/livecasino", img: card("casino-pt") },
          { name: "BetGames", code: "BETGAMES", type: "casino", path: "/livecasino", img: card("casino-bet") },
          { name: "Allbet", code: "ALLBET", type: "casino", path: "/livecasino", img: card("casino-allbet") },
          { name: "Asia Gaming", code: "AG", type: "casino", path: "/livecasino", img: card("casino-ag") },
          { name: "Pragmatic Live", code: "PPLIVE", type: "casino", path: "/livecasino", img: card("casino-pp") },
        ],
      },
      {
        title: "โต๊ะยอดนิยม & เกมไพ่",
        shape: "tile",
        items: [
          { name: "Evolution", code: "EVOLUTION", type: "casino", path: "/livecasino", img: tile("img-evo") },
          { name: "BBIN Live", code: "BBIN", type: "casino", path: "/livecasino", img: tile("img-bbin-live") },
          { name: "BG Casino", code: "BG", type: "casino", path: "/livecasino", img: tile("img-bg") },
          { name: "MG Live", code: "MG", type: "casino", path: "/livecasino", img: tile("img-mglive") },
          { name: "World Entertainment", code: "WE", type: "casino", path: "/livecasino", img: tile("img-nanyang") },
          { name: "Genesis", code: "GNS", type: "casino", path: "/livecasino", img: tile("img-gns") },
          { name: "Game Hall", code: "GAMEHALL", type: "casino", path: "/card", img: tile("img-gh-th") },
          { name: "ป๊อกเด้ง", code: "POKDENG", type: "casino", path: "/card", img: tile("img-ufa-pokdeng-th") },
        ],
      },
    ],
  },
  {
    id: "slot",
    label: "สล็อต",
    icon: `${A}/icons/cat-slot.webp`,
    groups: [
      {
        title: "ค่ายสล็อตชั้นนำ",
        shape: "portrait",
        items: [
          { name: "PG Soft", code: "PG", type: "slot", path: "/slot", img: card("slot-pg"), badge: "HOT" },
          { name: "Pragmatic Play", code: "PP", type: "slot", path: "/slot", img: card("slot-pp"), badge: "HOT" },
          { name: "JILI", code: "JILI", type: "slot", path: "/slot", img: card("slot-ji") },
          { name: "AMB Slot", code: "AMBSLOT", type: "slot", path: "/slot", img: card("slot-am") },
          { name: "AMB Poker", code: "AMBPOKER", type: "slot", path: "/slot", img: card("slot-amb") },
          { name: "Ameba", code: "AMEBA", type: "slot", path: "/slot", img: card("slot-ame") },
          { name: "AskMeBet", code: "ASKMEBET", type: "slot", path: "/slot", img: card("slot-ask") },
          { name: "Atom", code: "ATOM", type: "slot", path: "/slot", img: card("slot-atom") },
          { name: "Booongo", code: "BNG", type: "slot", path: "/slot", img: card("slot-boo") },
          { name: "Evoplay", code: "EVOPLAY", type: "slot", path: "/slot", img: card("slot-evo") },
          { name: "Funta Gaming", code: "FUNTA", type: "slot", path: "/slot", img: card("slot-fun") },
          { name: "Funky Games", code: "FUNKY", type: "slot", path: "/slot", img: card("slot-funky") },
          { name: "Gamatron", code: "GAMATRON", type: "slot", path: "/slot", img: card("slot-gama") },
          { name: "KA Gaming", code: "KA", type: "slot", path: "/slot", img: card("slot-ka") },
          { name: "Microgaming", code: "MG", type: "slot", path: "/slot", img: card("slot-mc") },
          { name: "Manna Play", code: "MANNA", type: "slot", path: "/slot", img: card("slot-mp") },
          { name: "Live22", code: "LIVE22", type: "slot", path: "/slot", img: card("slot-live") },
          { name: "Allwayspin", code: "ALLWAYSPIN", type: "slot", path: "/slot", img: card("slot-all") },
        ],
      },
    ],
  },
  {
    id: "sport",
    label: "กีฬา",
    icon: `${A}/icons/cat-sport.webp`,
    groups: [
      {
        title: "เว็บแทงกีฬา",
        shape: "portrait",
        items: [
          { name: "SBOBET", code: "SBO", type: "sport", path: "/sportbook", img: card("sport-sbo") },
          { name: "SABA Sports", code: "SABA", type: "sport", path: "/sportbook", img: card("sport-saba") },
          { name: "Pinnacle", code: "PINNACLE", type: "sport", path: "/sportbook", img: card("sport-pinnacle") },
          { name: "IM Sports", code: "IMSB", type: "sport", path: "/sportbook", img: card("sport-imsport") },
          { name: "IM E-Sports", code: "IMES", type: "sport", path: "/sportbook", img: card("sport-imesport") },
        ],
      },
      {
        title: "มวย ไก่ชน & กีฬาพิเศษ",
        shape: "tile",
        items: [
          { name: "เดิมพันกีฬา", code: "SPORTBOOK", type: "sport", path: "/sportbook", img: tile("img-sportsbook-square-th") },
          { name: "มวยไทย", code: "MUAYSTEP", type: "sport", path: "/sportbook", img: tile("img-muaystep-small-th") },
          { name: "ไก่ชนไทย", code: "COCKFIGHT", type: "sport", path: "/sportbook", img: tile("img-cockfight-square-th") },
          { name: "วัวชน", code: "BULLFIGHT", type: "sport", path: "/sportbook", img: tile("img-bullfight-square-th") },
          { name: "SV388", code: "SV388", type: "sport", path: "/sportbook", img: tile("img-sv388-square") },
          { name: "พักยก", code: "PAKYOK", type: "sport", path: "/sportbook", img: tile("img-tigerpakyok-square") },
          { name: "สนุกเกอร์", code: "SNOOKER", type: "sport", path: "/sportbook", img: tile("img-snooker-square-th") },
        ],
      },
    ],
  },
  {
    id: "fishing",
    label: "ยิงปลา",
    icon: `${A}/icons/cat-fishing.webp`,
    groups: [
      {
        title: "เกมยิงปลา",
        shape: "tile",
        items: [
          { name: "FA CHAI Fishing", code: "FC", type: "fishing", path: "/card", img: tile("uf-2"), badge: "HOT" },
          { name: "Spadegaming Fishing", code: "SG", type: "fishing", path: "/card", img: tile("uf-3") },
          { name: "AUG Fish", code: "AUG", type: "fishing", path: "/card", img: tile("img-aug-fish") },
          { name: "BBIN Fishing", code: "BBIN", type: "fishing", path: "/card", img: tile("img-bbinfish-fishing") },
          { name: "CQ9 Fish", code: "CQ9", type: "fishing", path: "/card", img: tile("img-cq9-fish") },
          { name: "FA CHAI", code: "FC", type: "fishing", path: "/card", img: tile("img-fachai-fishing") },
          { name: "Joker Fish", code: "JOKER", type: "fishing", path: "/card", img: tile("img-joker-fish") },
          { name: "MT Fish", code: "MT", type: "fishing", path: "/card", img: tile("img-mt-fish") },
          { name: "Play8 Fish", code: "PLAY8", type: "fishing", path: "/card", img: tile("img-play8-fish") },
          { name: "UFA Fishing", code: "UFAFISH", type: "fishing", path: "/card", img: tile("img-ufafishing") },
          { name: "UFA Slot Fish", code: "UFASLOT", type: "fishing", path: "/card", img: tile("img-ufa-slot-fish") },
        ],
      },
    ],
  },
  {
    id: "lotto",
    label: "หวย / คีโน",
    icon: `${A}/icons/cat-lotto.webp`,
    groups: [
      {
        title: "หวยออนไลน์",
        shape: "tile",
        items: [
          { name: "S-Lotto", code: "SLOTTO", type: "lotto", path: "/keno", img: tile("img-lotto-slotto") },
          { name: "UFA Lotto", code: "UFALOTTO", type: "lotto", path: "/keno", img: tile("img-lotto-ufa") },
        ],
      },
      {
        title: "คีโน",
        shape: "wide",
        items: [
          { name: "Keno Atom", code: "KENO", type: "lotto", path: "/keno", img: tile("keno-atom") },
          { name: "Keno Classic", code: "KENO", type: "lotto", path: "/keno", img: tile("keno-keno") },
          { name: "Number Games", code: "KENO", type: "lotto", path: "/keno", img: tile("keno-number") },
          { name: "Keno RNG", code: "KENO", type: "lotto", path: "/keno", img: tile("keno-rng") },
        ],
      },
    ],
  },
];

/* ------------------------------------------------------------ promo / partners */
export const LUX_PROMOS = [
  { id: "p1", img: `${A}/promo/p1.webp`, title: "โปรสมาชิกใหม่ รับโบนัสทันที" },
  { id: "p2", img: `${A}/promo/p2.webp`, title: "คืนยอดเสียทุกสัปดาห์" },
  { id: "p3", img: `${A}/promo/p3.webp`, title: "โปรฝากประจำ รับเครดิตเพิ่ม" },
  { id: "p4", img: `${A}/promo/p4.webp`, title: "แนะนำเพื่อน รับค่าคอมทุกวัน" },
];

export const LUX_PARTNERS = [
  "sa-gaming",
  "sexy-gaming",
  "dream-gaming",
  "pretty-gaming",
  "ag-gaming",
  "wm",
  "bg",
  "ebet",
  "aesexy",
  "jili",
  "joker-gaming",
  "spade-gaming",
  "live-22",
  "ameba",
  "ambbet",
  "ambpoker",
  "cq9",
  "kingmaker",
  "dragoonsoft",
  "gamatron",
  "deluxe",
  "gdg",
].map((id) => ({ id, img: `${A}/logos/${id}.webp` }));

export const LUX_FEATURES = [
  {
    id: "auto",
    icon: "solar:bolt-circle-bold-duotone",
    title: "ฝาก-ถอน ออโต้",
    text: "ระบบอัตโนมัติ ทำรายการเสร็จภายใน 30 วินาที",
  },
  {
    id: "secure",
    icon: "solar:shield-check-bold-duotone",
    title: "มั่นคง ปลอดภัย",
    text: "เว็บตรงไม่ผ่านเอเย่นต์ ข้อมูลเข้ารหัสทุกขั้นตอน",
  },
  {
    id: "support",
    icon: "solar:headphones-round-sound-bold-duotone",
    title: "ดูแล 24 ชั่วโมง",
    text: "ทีมงานมืออาชีพพร้อมดูแลคุณตลอดทุกวัน",
  },
  {
    id: "vip",
    icon: "solar:crown-star-bold-duotone",
    title: "สิทธิพิเศษ VIP",
    text: "คืนยอดเสีย กงล้อ เช็คอิน และโปรเฉพาะสมาชิก",
  },
];

export const LUX_STEPS = [
  {
    id: 1,
    img: `${A}/icons/step-register.webp`,
    title: "สมัครสมาชิก",
    text: "กรอกเบอร์โทรและบัญชีธนาคาร ใช้เวลาไม่ถึง 1 นาที",
  },
  {
    id: 2,
    img: `${A}/icons/step-deposit.webp`,
    title: "ฝากเงิน",
    text: "ฝากผ่านธนาคารหรือ TrueMoney ระบบออโต้ ไม่มีขั้นต่ำ",
  },
  {
    id: 3,
    img: `${A}/icons/step-bonus.webp`,
    title: "รับโบนัส & เริ่มเล่น",
    text: "เลือกโปรที่ชอบ แล้วเข้าเล่นได้ทุกค่ายทันที",
  },
];
